import { makeSelectors } from '@utils/css';

const transitionDurationMs = {
  enter: 375,
  exit: 300
};
const backdropCls = "dibblfyivb";
const contentCls = "dibc1edntar";
const panelCls = "dibp1827k3y";
const panelSelectors = makeSelectors({
  backdrop: backdropCls,
  content: contentCls,
  panel: panelCls
});

export { backdropCls, contentCls, panelCls, panelSelectors, transitionDurationMs };
import "./panel.style.linaria.module.css";
//# sourceMappingURL=panel.style.js.map
